import { request, createParams } from '../utils-tools/request';
const domain = window.location.host.indexOf('localhost') == -1 ? window.location.origin : 'http://ryyzs.dev-s.yunduoketang.cn';
const commonPath = '/saas-business'; //获取是否全部启用独立登录、注册页面

export async function CheckGlobalLogin() {
  let response = await request(createParams(`${commonPath}/v1/front/login/checkGlobalLogin?domain=${domain}`, 'GET'));
  return response;
}